import { type PreprocessingWorkflow } from "@/types/workflow";

export enum PREPROCESSING_WF_PAGE_PROCESS_TYPE {
  ALL = "all",
  SPECIFIC_PAGE = "specific_page",
  SPECIFIC_RANGE = "specific_range",
}

export enum PREPROCESSING_WF_UPLOAD_MODE {
  WHOLE_FILE = "whole-file",
  // The new mode
  SPLIT_BY_PAGES = "split-by-pages",
}

export const splitPageModes = [PREPROCESSING_WF_UPLOAD_MODE.SPLIT_BY_PAGES];

export const DEFAULT_PREPROCESSING_WF_CONFIG: PreprocessingWorkflow = {
  uploadMode: PREPROCESSING_WF_UPLOAD_MODE.WHOLE_FILE,
  rotation: false,
  processingPages: { type: PREPROCESSING_WF_PAGE_PROCESS_TYPE.ALL, value: null },
  pagesPerFile: "1",
};

export const DEFAULT_PREPROCESSING_WF_CONFIG_SPLIT_BY_PAGES: PreprocessingWorkflow = {
  uploadMode: PREPROCESSING_WF_UPLOAD_MODE.SPLIT_BY_PAGES,
  rotation: false,
  processingPages: { type: PREPROCESSING_WF_PAGE_PROCESS_TYPE.ALL, value: null },
  pagesPerFile: "1",
};

export interface PreprocessingUploadModeOption {
  label: string;
  value: PREPROCESSING_WF_UPLOAD_MODE;
}
export const preprocessingUploadModeOptions: PreprocessingUploadModeOption[] = [
  {
    label: "COMMON.WHOLE_FILE",
    value: PREPROCESSING_WF_UPLOAD_MODE.WHOLE_FILE,
  },
  {
    label: "COMMON.SPLIT_BY_PAGES",
    value: PREPROCESSING_WF_UPLOAD_MODE.SPLIT_BY_PAGES,
  },
];

// TODO: Remove this after release SPLIT_BY_PAGE
export const preprocessingUploadModeOptionsOld: PreprocessingUploadModeOption[] = [
  {
    label: "COMMON.WHOLE_FILE",
    value: PREPROCESSING_WF_UPLOAD_MODE.WHOLE_FILE,
  },
];
